<template>
	<transition-group
		name="component-fade-slow"
		tag="div"
		class="alerts"
	>
		<core-alert
			v-for="(alert, index) in alerts"
			:key="'_' + index"
			:type="alert.type"
			:index="index"
			:close="alert.close"
			:closes="alert.closes"
			:meta="alert.meta"
			:icon="alert.icon"
		>
			<div v-html="message(alert)"></div>
		</core-alert>
	</transition-group>
</template>

<script>
export default {
	props : {
		alerts : {
			type     : Array,
			required : true,
		},
	},
	methods : {
		invalidCredentials (alert) {
			const search = 'authentication credentials given are invalid'
			const invalid = alert.message.indexOf(search)
			return -1 !== invalid
		},
		message (alert) {
			const pre = 'Something went wrong while fetching data.'
			let msg = alert.message.replace(pre, `<span class="omapi-alert__primary">${pre}</span>`)

			if (this.invalidCredentials(alert)) {
				msg += ' <a class="omapi-link-arrow-after" href="?page=optin-monster-settings">Go to Settings</a>'
			}
			return msg
		},
	},
}
</script>
